import $ from 'jquery';
import ProductDetails from '../snippets/ProductDetails';
import ProductHighlights from '../snippets/ProductHighlights';

import ProductMenu from '../snippets/ProductMenu';

export default class Product {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    const onboarding = section.data.onboarding;

    // Product details
    this.productDetails = new ProductDetails(this.$el, section);

    // Product menu
    if (!onboarding && !this.section.data.form_is_inline) {
      this.productMenu = new ProductMenu(section.el.querySelector('[data-product-menu]'), this.section.data, this.section.postMessage);
    }

    // Related products
    const $related = $('[data-product-highlights]', this.$el);
    if ($related.length) {
      this.related = new ProductHighlights($related, this.section.postMessage);
    }
  }

  onSectionUnload() {
    if (this.related) this.related.unload();
    if (this.productMenu) this.productMenu.unload();
    this.productDetails.unload();
  }
}
